<div class="general-tasks-header">
  <div class="general-tasks-project-name">
    <svg-icon src='./assets/icons/Project_icon.svg'
              class="menu-action-icon svg-icon-large svg-icon-black" title="{{ 'raci.generalTasks.project' | translate }}"></svg-icon>
    <div>
      <input type="checkbox"
             [ngClass]="data.dateApproved != null ? 'property-approved' : !data.isCompleted && data.dateRejected ? 'property-rejected' : ''"
             [(ngModel)]="isProjectSelected"
             (click)="selectAllProperties()" />
    </div>
    <h3 style="padding-left: 10px;">{{data?.capForceProject?.ProjectName}}</h3>
  </div>
  <div class="general-tasks-info">
    <p class="general-tasks-title">{{ 'raci.generalTasks.approval' | translate | uppercase }}</p>
    <p *ngIf="!data?.dateApproved && data?.dateRejected" class="general-tasks-info-date">
      {{ data?.dateRejected | date: 'dd.MM.YYYY' }}
    </p>
    <p *ngIf="data?.dateApproved" class="general-tasks-info-date">
      {{ data?.dateApproved | date: 'dd.MM.YYYY' }}
    </p>
    <p class="general-tasks-info-user" [ngClass]="!isProjectSelected ? getTaskCompletedClass() : 'selected-all'">{{currentUser?.User_Description}}</p>
  </div>
</div>
<div class="general-tasks-body"
     *ngIf="!groupBy">
  <div class="general-tasks-grid-divader">
    <svg-icon src='./assets/icons/Properties_icon.svg'
              title="{{ 'raci.generalTasks.properties' | translate }}"
              class="menu-action-icon svg-icon-large svg-icon-black"
              align='center'>
    </svg-icon>
    <hr class="vertical-line" />
  </div>
  <div class="general-tasks-grid">
    <kendo-grid [data]="properties"
                #generalTasksApprovalGrid
                [selectable]="selectableSettings"
                (selectionChange)="changeSelectedRow($event)"
                class="kendo-white-grid approval-grid custom-participants-grid">
      <kendo-grid-column field="PropertyName"
                         title="Property Name"
                         class="fill-line"
                         [width]="fit-content">
      </kendo-grid-column>
      <kendo-grid-column field="PropertyCity"
                         title="City"
                         [width]="fit-content">
      </kendo-grid-column>
      <kendo-grid-column field="PropertyStreet"
                         title="Property Address"
                         [width]="fit-content">
      </kendo-grid-column>
      <kendo-grid-column field="PropertyType"
                         title="Property Type"
                         [width]="fit-content">
      </kendo-grid-column>
      <kendo-grid-column field="requestDescription"
                         title="Request Description"
                         [width]="fit-content">
      </kendo-grid-column>
      <kendo-grid-column field="OpportunityPropertyId"
                         title="Capforce ID"
                         [width]="fit-content">
      </kendo-grid-column>
      <kendo-grid-column field="PropertyHorizonId"
                         title="Horizon ID"
                         [width]="fit-content">
      </kendo-grid-column>
      <kendo-grid-column field="PropertyMDMId"
                         title="MDM ID"
                         [width]="fit-content">
      </kendo-grid-column>
      <kendo-grid-column [width]="170">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="general-tasks-info" *ngIf="data?.dateApproved || data?.dateRejected">
            <p *ngIf="!data?.dateApproved && data?.dateRejected" class="general-tasks-info-date">
              {{ data?.dateRejected | date: 'dd.MM.YYYY' }}
            </p>
            <p *ngIf="data?.dateApproved" class="general-tasks-info-date">
              {{ data?.dateApproved | date: 'dd.MM.YYYY' }}
            </p>
            <p class="general-tasks-info-user" [ngClass]="getTaskCompletedClass()">{{currentUser?.User_Description}}</p>
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
<div class="general-grouped-tasks-body"
     *ngIf="groupBy">
  <div class="grouped-general-tasks-body"
       *ngFor="let groupedItem of groupData">
    <div class="grouped-item-header">

      <svg-icon src='./assets/icons/Properties_icon.svg'
                title="{{ 'raci.generalTasks.properties' | translate }}"
                class="menu-action-icon svg-icon-large svg-icon-black"
                align='center'>
      </svg-icon>
      <h3>{{groupedItem.group}}</h3>
    </div>
    <div class="general-tasks-grid grid-border-left">
      <kendo-grid [data]="groupedItem.properties"
                  #generalTasksApprovalGrid
                  class="kendo-white-grid approval-grid">
        <kendo-grid-column field="PropertyName"
                           title="Property Name"
                           class="fill-line"
                           [width]="fit-content">
        </kendo-grid-column>
        <kendo-grid-column field="PropertyCity"
                           title="City"
                           [width]="fit-content">
        </kendo-grid-column>
        <kendo-grid-column field="PropertyStreet"
                           title="Property Address"
                           [width]="fit-content">
        </kendo-grid-column>
        <kendo-grid-column field="PropertyType"
                           title="Property Type"
                           [width]="fit-content">
        </kendo-grid-column>
        <kendo-grid-column field="requestDescription"
                           title="Request Description"
                           [width]="auto">
        </kendo-grid-column>

        <kendo-grid-column field="OpportunityPropertyId"
                           title="Capforce ID"
                           [width]="fit-content">
        </kendo-grid-column>
        <kendo-grid-column field="PropertyHorizonId"
                           title="Horizon ID"
                           [width]="fit-content">
        </kendo-grid-column>
        <kendo-grid-column field="PropertyMDMId"
                           title="MDM ID"
                           [width]="fit-content">
        </kendo-grid-column>
        <kendo-grid-column>
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="general-tasks-info" *ngIf="data?.dateApproved || data?.dateRejected">
              <p *ngIf="!data?.dateApproved && data?.dateRejected" class="general-tasks-info-date">
                {{ data?.dateRejected | date: 'dd.MM.YYYY' }}
              </p>
              <p *ngIf="data?.dateApproved" class="general-tasks-info-date">
                {{ data?.dateApproved | date: 'dd.MM.YYYY' }}
              </p>
              <p class="general-tasks-info-user" [ngClass]="getTaskCompletedClass()">{{currentUser?.User_Description}}</p>
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
</div>
<raci-approval-dialog class="raci-approval-matrix-dialog" *ngIf="isApprovalDialogDisplayed" [isGeneralTask]="true" [selectedGeneralTask]="data" (onApprove)="onApprove($event)"></raci-approval-dialog>
